import * as z from 'zod';

/**
 * PAY-4392: what `claim_app_release_celebration` returned, reduced to the one
 * question the client asks: show the notice, and with what text?
 *
 * Anything unexpected (an outcome this build does not know, a malformed note)
 * is treated as "show nothing" or "show the generic message", never thrown.
 */

const ClaimResultSchema = z.object({
  outcome: z.string(),
  release_number: z.string().nullish(),
  summary_lines: z.array(z.string()).nullish(),
});

export type ClaimDecision =
  | { show: false }
  | { show: true; releaseNumber: string | null; lines: string[] | null };

/**
 * The server allows one text of at most this many characters: the verse, its
 * lines separated by `\n` (PAY-4474).
 */
const MAX_POEM_LENGTH = 480;

export function interpretClaimResult(value: unknown): ClaimDecision {
  const parsed = ClaimResultSchema.safeParse(value);
  if (!parsed.success || parsed.data.outcome !== 'show') return { show: false };

  const releaseNumber = parsed.data.release_number?.trim() || null;
  const raw = parsed.data.summary_lines ?? null;
  const poem = raw?.length === 1 ? (raw[0]?.trim() ?? '') : '';
  const lines =
    poem.length > 0 && poem.length <= MAX_POEM_LENGTH ? [poem] : null;

  return { show: true, releaseNumber, lines };
}
